import { Theme } from '@eversports/react-components/design-tokens/theme'
import Skeleton from '@eversports/react-components/primitives/Skeleton'
import MuiStep from '@mui/material/Step'
import MuiStepLabel from '@mui/material/StepLabel'
import MuiStepper from '@mui/material/Stepper'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { Localized } from '../../localization/react'

export interface Step {
  labelKey: string
  path: string
}

interface Props {
  steps: Array<Step>
  isLoading: boolean
}
function getActiveStep(steps: Array<Step>, activePath: string): Step | undefined {
  return steps.find(({ path }) => path === activePath)
}

const useStyles = makeStyles((theme: Theme) => ({
  stepper: {
    backgroundColor: 'transparent',
    padding: theme.spacing(5),
  },
  stepLabel: {
    [theme.breakpoints.down(420)]: {
      display: 'none',
    },
  },
}))

const NUMBER_OF_SKELETON_STEPS = 5
const skeletonSteps = [...Array(NUMBER_OF_SKELETON_STEPS)]

const StepperComponent: React.FC<React.PropsWithChildren<Props>> = ({ steps, isLoading }) => {
  const classes = useStyles()
  const location = useLocation()

  if (isLoading) {
    return (
      <MuiStepper activeStep={-1} alternativeLabel className={classes.stepper}>
        {skeletonSteps.map((_, i) => (
          <MuiStep key={i}>
            <MuiStepLabel>
              <span className={classes.stepLabel}>
                <Skeleton />
              </span>
            </MuiStepLabel>
          </MuiStep>
        ))}
      </MuiStepper>
    )
  }

  const activePath = location.pathname
  const visibleSteps = steps && [...new Set(steps.map(({ labelKey }) => labelKey))]
  const activeStep = steps && getActiveStep(steps, activePath)
  const activeStepIndex = visibleSteps && activeStep && visibleSteps.findIndex((value) => value === activeStep.labelKey)

  return (
    <MuiStepper activeStep={activeStepIndex} alternativeLabel className={classes.stepper}>
      {visibleSteps.map((labelKey) => (
        <MuiStep key={labelKey}>
          <MuiStepLabel>
            <span className={classes.stepLabel}>
              <Localized id={labelKey as any} />
            </span>
          </MuiStepLabel>
        </MuiStep>
      ))}
    </MuiStepper>
  )
}

export default StepperComponent
